module.exports = __webpack_public_path__ + "static/logo-fastcompany-e90207f03faecfaf783104993d54caed.png";